export enum ToolType {
  PREVERIFIED_LCA_TOOL = 'PreverifiedLCATool',
  PREVERIFIED_EPD_TOOL = 'PreverifiedEPDTool',
  FULLY_PREVERIFIED_TOOL = 'FullyPreverifiedTool',
}
